import { UseQueryOptions, useQuery } from 'react-query';
import apiClient from '../apiClient';
import { ApiResponseType, PaginationResponseType, responseWrapper } from '../helpers';
import { API_QUERIES } from '../keys';
import { Regions } from './type';

export function useGetListRegion(
  options: UseQueryOptions<ApiResponseType<PaginationResponseType<Regions>>, Error>
) {
  const { data: regions, refetch: onGetListRegions } = useQuery<
    ApiResponseType<PaginationResponseType<Regions>>,
    Error
  >([API_QUERIES.LIST_REGION], {
    queryFn: (query) => {
      const [_, ...params] = query.queryKey;
      return responseWrapper<ApiResponseType<PaginationResponseType<Regions>>>(
        apiClient.getListRegion,
        params
      );
    },
    select: (data) => {
      return data;
    },
    notifyOnChangeProps: ['data', 'isFetching'],
    keepPreviousData: true,
    ...options,
  });
  return {
    regions,
    onGetListRegions,
  };
}
